"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getType = getType;
exports.getTypeFromActionCreator = getTypeFromActionCreator;
exports["default"] = void 0;

function getType(action) {
  return action.type;
}

function getTypeFromActionCreator(actionCreator) {
  if (!actionCreator().type) {
    throw new Error("Action creator that has been passed to getType() does not provide any API to expose action type.");
  }

  return getType(actionCreator());
}

var _default = getTypeFromActionCreator;
exports["default"] = _default;
//# sourceMappingURL=getTypeFromActionCreator.js.map